import React, { useState } from "react";
import Select from "react-select";
import requests from "./base";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const RegisterVendor = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    VendorName: "",
    RegistrationNo: "",
    KRA_PIN: "",
    BusinessPermit: "",
    PhoneNumber: "",

    Country: "",
    County: "",
    SubCounty: "",
    Ward: "",
    Village: "",
    Email: "",
    Password: "",
    ConfirmPassword: "",
    IDNumber: "",
    BusinessName: "",
    BusinessEmail: "",
    KRAcert: "",
    PermitCert: "",
    RegDoc: "",
    StartingPoint: "",
    CanDeliver: "2",
    DeliveryRadius: 0,
  });

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude.toString();
          const lng = position.coords.longitude.toString();
          const locationObject = { lat, lng };

          setFormData((prev) => ({
            ...prev,
            StartingPoint: JSON.stringify(locationObject),
          }));
        },
        (error) => {
          alert("Unable to retrieve location: " + error.message);
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const countryOptions = [
    { value: 1, label: "Kenya" },
    { value: 2, label: "Uganda" },
    { value: 3, label: "Tanzania" },
    { value: 4, label: "Zambia" },
    { value: 5, label: "Nigeria" },
    { value: 6, label: "Zimbabwe" },
  ];

  const [errors, setErrors] = useState({});
  const [countyOptions, setCountyOptions] = useState([]);
  const [subCountyOptions, setSubCountyOptions] = useState([]);
  const [wardOptions, setWardOptions] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const sortedCountyOptions = [...countyOptions].sort((a, b) =>
    a.Name.localeCompare(b.Name)
  );
  const sortedSubCountyOptions = [...subCountyOptions].sort((a, b) =>
    a.Name.localeCompare(b.Name)
  );
  const sortedWardOptions = [...wardOptions].sort((a, b) =>
    a.Name.localeCompare(b.Name)
  );

  // Handle Country Change
  const handleCountryChange = async (e) => {
    const selectedCountryId = parseInt(e.target.value);
    setFormData((prev) => ({
      ...prev,
      Country: selectedCountryId,
      County: "",
      SubCounty: "",
      Ward: "",
    }));

    try {
      const response = await requests.get(
        `/getboundary0?countryid=${selectedCountryId}`
      );
      if (response.ResponseCode === 0) {
        setCountyOptions(response.Data || []);
      } else if (!selectedCountryId) {
        swal("Error", "Please Select a valid country", "error");
      } else {
        swal("Error", "Unexpected server response", "error");
        console.warn("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error loading counties:", error);
      setCountyOptions([]);
    }

    setSubCountyOptions([]);
    setWardOptions([]);
  };

  // Handle County Change
  const handleCountyChange = async (e) => {
    const selectedCountyId = parseInt(e.target.value);
    setFormData((prev) => ({
      ...prev,
      County: selectedCountyId,
      SubCounty: "",
      Ward: "",
    }));

    try {
      const response = await requests.get(
        `/getboundary1?countyid=${selectedCountyId}`
      );
      setSubCountyOptions(response.Data || []);
    } catch (error) {
      console.error("Error loading subcounties:", error);
      setSubCountyOptions([]);
    }

    setWardOptions([]);
  };

  // Handle SubCounty Change
  const handleSubCountyChange = async (e) => {
    const selectedSubCountyId = parseInt(e.target.value);
    setFormData((prev) => ({
      ...prev,
      SubCounty: selectedSubCountyId,
      Ward: "",
    }));

    try {
      const response = await requests.get(
        `/getboundary2?subcountyid=${selectedSubCountyId}`
      );
      setWardOptions(response.Data || []);
    } catch (error) {
      console.error("Error loading wards:", error);
      setWardOptions([]);
    }
  };

  const countySelectOptions = sortedCountyOptions.map((c) => ({
    value: c.Id,
    label: c.Name,
  }));

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (type === "file") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0], // Store the File object
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const validateRequiredFields = () => {
    const newErrors = {};
    if (step === 1) {
      if (!formData.VendorName)
        newErrors.VendorName = "Vendor Name is required";

      if (!formData.RegistrationNo)
        newErrors.RegistrationNo = "Registration No is required";
      if (!formData.BusinessPermit)
        newErrors.BusinessPermit = "Business Permit Name is required";
      if (!formData.PhoneNumber) {
        newErrors.PhoneNumber = "Phone Number is required";
      } else {
        // Remove all non-digit characters and check length
        const phoneDigits = formData.PhoneNumber.replace(/\D/g, "");
        if (phoneDigits.length < 12) {
          newErrors.PhoneNumber =
            "Phone number is too short (must be 12 digits)";
        } else if (phoneDigits.length > 12) {
          newErrors.PhoneNumber =
            "Phone number is too long (must be 12 digits)";
        }
      }
    } else if (step === 2) {
      if (!formData.Country) newErrors.Country = "Country is required";
      if (!formData.County) newErrors.County = "County is required";
      if (formData.CanDeliver === "1") {
        if (!formData.DeliveryRadius) {
          newErrors.DeliveryRadius = "Delivery Radius is required";
        }

        if (!formData.StartingPoint) {
          newErrors.StartingPoint = "Starting Point is required";
        }
      }
    } else if (step === 3) {
      if (!formData.Email) {
        newErrors.Email = "Email is required";
      } else {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(formData.Email)) {
          newErrors.Email = "Invalid email";
        }
      }
      if (!formData.BusinessEmail) {
        newErrors.BusinessEmail = "Email is required";
      } else {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(formData.BusinessEmail)) {
          newErrors.BusinessEmail = "Invalid email";
        }
      }
      if (!formData.Password) newErrors.Password = "Password is required";
      if (!formData.ConfirmPassword)
        newErrors.ConfirmPassword = "Confirm Password is required";
      if (formData.Password !== formData.ConfirmPassword)
        newErrors.ConfirmPassword = "Passwords do not match";
      if (!formData.IDNumber) {
        newErrors.IDNumber = "Phone Number is required";
      } else {
        // Remove all non-digit characters and check length
        const IDNumberDigits = formData.IDNumber.replace(/\D/g, "");
        if (IDNumberDigits.length < 8) {
          newErrors.IDNumber =
            "ID number is too short (must be not less than 8 digits and not more than 10 digits)";
        } else if (IDNumberDigits.length > 10) {
          newErrors.IDNumber =
            "ID number is too Long (must be not less than 8 digits and not more than 10 digits)";
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateRequiredFields();
    if (!isValid) {
      return; // Stop submission if validation fails
    }

    const body = {
      id: 16,
      title: "Vendor Registration Form",
      sections: [
        {
          title: "Vendor details",
          id: 1,
          components: [
            { id: 1, value: formData.VendorName },
            { id: 2, value: formData.RegistrationNo },
            { id: 3, value: formData.KRA_PIN },
            { id: 4, value: formData.BusinessPermit },
            { id: 5, value: formData.PhoneNumber },
            { id: 6, value: formData.CanDeliver },
            { id: 7, value: formData.DeliveryRadius },
            { id: 8, value: formData.Country },
            { id: 9, value: formData.County },
            { id: 10, value: formData.SubCounty },
            { id: 11, value: formData.Ward },
            { id: 12, value: formData.Village },
            { id: 13, value: 0 },
            { id: 14, value: formData.Email },
            { id: 15, value: formData.Password },
            { id: 16, value: formData.IDNumber },
            { id: 17, value: formData.BusinessName },
            { id: 18, value: formData.BusinessEmail },
          ],
        },
      ],
    };

    try {
      const response = await requests.post("/Registervendor", body);
      if (
        response?.ResponseCode === 0 &&
        response.ResponseMessage.includes(formData.RegistrationNo)
      ) {
        setStep(1); 

        // Set validation error on RegistrationNo field
        setErrors((prev) => ({
          ...prev,
          RegistrationNo: "This Registration Number already exists.",
        }));

        return;
      } else if (
        response?.ResponseCode === 0 &&
        response.ResponseMessage === "Error: Duplicate data exists: RegistrationNo already used."
      ) {
        setStep(3);

        // Set validation error on RegistrationNo field
        setErrors((prev) => ({
          ...prev,
          Email: "This email is already registered. Please log in or contact your system administrator if you’ve forgotten your password..",
        }));

        return;
      } else if (response?.ResponseCode === 1) {
        swal("Success", response.ResponseMessage, "success");
        navigate("/login");
      } else {
        swal(
          "Error",
          response?.ResponseMessage || "Failed to register",
          "error"
        );
      }
    } catch (error) {
      console.error("Registration error:", error);
    }
  };

  const steps = ["Personal Info", "Location and Delivery Info", "Account Info"];

  return (
    <div
      style={{
        backgroundColor: "#00253d",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          width: "100%",
          maxWidth: "700px",
        }}
      >
        <div className="text-center mb-3">
          <img
            src="../acre-africa-full-black-logo.svg"
            alt="Logo"
            style={{ height: "40px", objectFit: "contain" }}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "30px",
            alignItems: "center",
          }}
        >
          {steps.map((label, index) => {
            const stepIndex = index + 1;
            const isCompleted = step > stepIndex;
            const isCurrent = step === stepIndex;

            return (
              <React.Fragment key={index}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      backgroundColor:
                        isCompleted || isCurrent ? "#f5821f" : "#ccc",
                      color: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: "bold",
                      transition: "0.3s",
                    }}
                  >
                    {stepIndex}
                  </div>
                  <div
                    style={{
                      marginTop: 5,
                      fontSize: "12px",
                      color: "#333",
                      textAlign: "center",
                    }}
                  >
                    {label}
                  </div>
                </div>

                {stepIndex < steps.length && (
                  <div
                    style={{
                      flex: 1,
                      height: 2,
                      backgroundColor: "#ccc",
                      margin: "0 10px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        right: -5,
                        top: -5,
                        width: 0,
                        height: 0,
                        borderTop: "7px solid transparent",
                        borderBottom: "7px solid transparent",
                        borderLeft: "10px solid #ccc",
                      }}
                    />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>

        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
            }}
          >
            {step === 1 && (
              <>
                <Input
                  label="Vendor Name"
                  name="VendorName"
                  value={formData.VendorName}
                  onChange={handleChange}
                  error={errors.VendorName}
                  className="custom-input"
                  required
                />
                <div style={{ gridColumn: "span 1", marginTop: "5px" }}>
                  <label>
                    Phone Number <span style={{ color: "red" }}> *</span>
                  </label>{" "}
                  <br />
                  <PhoneInput
                    country={"ke"}
                    onlyCountries={["ke"]}
                    value={formData.PhoneNumber}
                    onChange={(phone) => {
                      const last9 = phone.slice(-9);
                      const formatted = "+" + phone.replace(/[^0-9]/g, "");
                      setFormData((prev) => ({
                        ...prev,
                        PhoneNumber: formatted,
                        Last9Digits: last9,
                      }));
                    }}
                    inputProps={{
                      name: "PhoneNumber",
                      required: true,
                      maxLength: 16,
                    }}
                    enableSearch
                    countryCodeEditable={false}
                    inputStyle={{
                      // or '300px', '50%' etc.
                      height: "50px",
                    }}
                  />
                  {errors.PhoneNumber && (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errors.PhoneNumber}
                    </div>
                  )}
                </div>
                <Input
                  label="Registration No"
                  name="RegistrationNo"
                  value={formData.RegistrationNo}
                  onChange={handleChange}
                  error={errors.RegistrationNo}
                  required
                />

                <Input
                  label="Business Permit"
                  name="BusinessPermit"
                  value={formData.BusinessPermit}
                  onChange={handleChange}
                  error={errors.BusinessPermit}
                  required
                />
                <Input
                  label="KRA PIN"
                  name="KRA_PIN"
                  value={formData.KRA_PIN}
                  onChange={handleChange}
                  required
                />
                <div style={{ gridColumn: "span 1" }}>
                  <Input
                    label="Business Permit document"
                    name="PermitCert"
                    type="file"
                    onChange={handleChange}
                    error={errors.PermitCert}
                  />
                  {formData.PermitCert && (
                    <div
                      style={{
                        fontSize: "12px",
                        gridColumn: "span 2",
                        color: "green",
                      }}
                    >
                      Selected: {formData.PermitCert.name}
                    </div>
                  )}
                </div>
                <div style={{ gridColumn: "span 1" }}>
                  <Input
                    label="KRA_PIN Certificate document"
                    name="KRAcert"
                    type="file"
                    onChange={handleChange}
                    error={errors.KRAcert}
                  />
                  {formData.KRAcert && (
                    <p style={{ fontSize: "12px", color: "green" }}>
                      Selected: {formData.KRAcert.name}
                    </p>
                  )}
                </div>
                <div style={{ gridColumn: "span 1" }}>
                  <Input
                    label="Registration document"
                    name="RegDoc"
                    type="file"
                    onChange={handleChange}
                    error={errors.RegDoc}
                  />
                  {formData.KRAcert && (
                    <div style={{ fontSize: "12px", color: "green" }}>
                      Selected: {formData.RegDoc.name}
                    </div>
                  )}
                </div>
              </>
            )}
            {step === 2 && (
              <>
                {/* country */}
                <div className="form-group">
                  <label>
                    Country <span style={{ color: "red" }}> *</span>
                  </label>{" "}
                  <br />
                  <select
                    name="Country"
                    required
                    value={formData.Country}
                    onChange={handleCountryChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid rgb(190, 193, 200)",
                      borderRadius: "5px",
                      marginTop: "7px",
                    }}
                  >
                    <option value="">-- Select Country --</option>
                    {countryOptions.map((country) => (
                      <option key={country.value} value={country.value}>
                        {country.label}
                      </option>
                    ))}
                  </select>
                  {errors.Country && (
                    <div className="error">
                      {" "}
                      <span>{errors.Country}</span>
                    </div>
                  )}
                </div>

                {/* County Dropdown */}
                <div className="form-group">
                  <label>
                    County <span style={{ color: "red" }}> *</span>
                  </label>{" "}
                  <br />
                  <select
                    name="County"
                    value={formData.County}
                    onChange={handleCountyChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid rgb(190, 193, 200)",
                      borderRadius: "5px",
                      marginTop: "7px",
                    }}
                  >
                    <option value="">-- Select County --</option>
                    {sortedCountyOptions.map((county) => (
                      <option key={county.Id} value={county.Id}>
                        {county.Name}
                      </option>
                    ))}
                  </select>
                  {errors.County && (
                    <div className="error">{errors.County}</div>
                  )}
                </div>

                {/* SubCounty Dropdown */}
                <div className="form-group">
                  <label>SubCounty</label>
                  <br />
                  <select
                    name="SubCounty"
                    value={formData.SubCounty}
                    onChange={handleSubCountyChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid rgb(190, 193, 200)",
                      borderRadius: "5px",
                      marginTop: "7px",
                    }}
                  >
                    <option value="">-- Select SubCounty --</option>
                    {subCountyOptions.map((sub) => (
                      <option key={sub.Id} value={sub.Id}>
                        {sub.Name}
                      </option>
                    ))}
                  </select>
                  {errors.SubCounty && (
                    <div className="error">{errors.SubCounty}</div>
                  )}
                </div>

                {/* Ward Dropdown */}
                <div className="form-group">
                  <label>Ward</label> <br />
                  <select
                    name="Ward"
                    value={formData.Ward}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid rgb(190, 193, 200)",
                      borderRadius: "5px",
                      marginTop: "7px",
                    }}
                  >
                    <option value="">-- Select Ward --</option>
                    {wardOptions.map((w) => (
                      <option key={w.Id} value={w.Id}>
                        {w.Name}
                      </option>
                    ))}
                  </select>
                  {errors.Ward && <div className="error">{errors.Ward}</div>}
                </div>

                <Input
                  label="Village"
                  name="Village"
                  value={formData.Village}
                  onChange={handleChange}
                />

                {/* Can Deliver */}
                <div style={{ gridColumn: "span 1" }}>
                  <label>Can Deliver?</label>
                  <br />
                  <label style={{ marginRight: "10px" }}>
                    <input
                      type="radio"
                      name="CanDeliver"
                      value="1"
                      onChange={handleChange}
                      checked={formData.CanDeliver === "1"}
                    />{" "}
                    Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="CanDeliver"
                      value="2"
                      onChange={handleChange}
                      checked={formData.CanDeliver === "2"}
                    />{" "}
                    No
                  </label>
                </div>

                {/* Conditionally Show Delivery Fields */}
                {formData.CanDeliver === "1" && (
                  <>
                    {/* Delivery Radius */}
                    <Input
                      label="Delivery Radius"
                      name="DeliveryRadius"
                      type="number"
                      value={formData.DeliveryRadius}
                      onChange={handleChange}
                      error={errors.DeliveryRadius}
                    />

                    {/* Starting Point */}
                    <div className="form-group">
                      <label>Starting Point (GPS Coordinates)</label>
                      <div style={{ marginBottom: "10px" }}>
                        <button
                          type="button"
                          onClick={getCurrentLocation}
                          style={{
                            border: "none",
                            backgroundColor: "#00253d",
                            color: "white",
                            borderRadius: "5px",
                          }}
                        >
                          Use Current Location
                        </button>
                        <input
                          type="text"
                          name="StartingPoint"
                          value={formData.StartingPoint}
                          readOnly
                          placeholder='{"lat":"...","lng":"..."}'
                          style={{ width: "100%", border: "none" }}
                        />
                        {errors.StartingPoint && (
                          <div>{errors.StartingPoint}</div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            {step === 3 && (
              <>
                <Input
                  label="Business Email"
                  name="BusinessEmail"
                  type="text"
                  value={formData.BusinessEmail}
                  onChange={handleChange}
                  error={errors.BusinessEmail}
                />

                <Input
                  label="Business Name"
                  name="BusinessName"
                  type="text"
                  value={formData.BusinessName}
                  onChange={handleChange}
                  error={errors.BusinessName}
                />
                <Input
                  label="Email"
                  name="Email"
                  type="text"
                  value={formData.Email}
                  onChange={handleChange}
                  error={errors.Email}
                />
                <Input
                  label="ID Number"
                  name="IDNumber"
                  type="number"
                  value={formData.IDNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      handleChange(e);
                    }
                  }}
                  error={errors.IDNumber}
                />

                <div style={{ position: "relative" }}>
                  <Input
                    label="Password"
                    name="Password"
                    type={showPassword ? "text" : "password"}
                    value={formData.Password}
                    onChange={handleChange}
                    error={errors.Password}
                    style={{
                      backgroundColor: "white",
                    }}
                  />
                  <span
                    className={`mdi ${
                      showPassword
                        ? "mdi mdi-eye-off-outline"
                        : "mdi mdi-eye-outline"
                    }`}
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "37px",
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#555",
                    }}
                  ></span>
                </div>

                <Input
                  label="Confirm Password"
                  name="ConfirmPassword"
                  type={showPassword ? "text" : "password"}
                  value={formData.ConfirmPassword}
                  onChange={handleChange}
                  error={errors.ConfirmPassword}
                />
              </>
            )}
          </div>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {step > 1 && (
              <button
                type="button"
                onClick={() => setStep(step - 1)}
                style={buttonStyle}
              >
                Previous
              </button>
            )}
            {step < 3 && (
              <button
                type="button"
                onClick={() => validateRequiredFields() && setStep(step + 1)}
                style={buttonStyle}
              >
                Continue
              </button>
            )}
            {step === 3 && (
              <button
                type="submit"
                style={buttonStyle}
                onClick={() => validateRequiredFields()}
              >
                Submit
              </button>
            )}
          </div>
        </form>
        <small className="m-3">
          {" "}
          Already have an account{" "}
          <a href="/login" style={{ color: "#f5821f" }}>
            Login{" "}
          </a>
        </small>
      </div>
    </div>
  );
};

// Input component with error display and red border
const Input = ({
  label,
  name,
  value,
  onChange,
  required,
  type = "text",
  error,
}) => (
  <div>
    <label htmlFor={name}>
      {label} {required && <span style={{ color: "red" }}>*</span>}
    </label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      style={{
        width: "100%",
        padding: "10px",
        borderRadius: "5px",
        border: `1px solid ${error ? "red" : "#ccc"}`,
        marginTop: "5px",
      }}
    />
    {error && (
      <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
        {error}
      </div>
    )}
  </div>
);

const buttonStyle = {
  padding: "10px 20px",
  backgroundColor: "#00253d",
  color: "#fff",
  borderRadius: "5px",
  border: "none",
  cursor: "pointer",
};

export default RegisterVendor;
